import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-category-web',
  templateUrl: './category-web.component.html',
  styleUrls: ['./category-web.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule]
})
export class CategoryWebComponent  implements OnInit {
  @Input() category: any = {};
  @Input() isMobile: boolean = false;
  constructor() { }

  ngOnInit() {}

}
